import React, { Component } from "react";
import { Button, Row, Typography, Spin, Alert, Switch } from "antd";
import QRScanner from "../../../components/QRScanner/QRScanner";
import routesConfig from "../../../routesConfig";
import { withRouter } from "react-router";
import { cameraAsked } from "store/app/actions";
import { connect } from "react-redux";
import { LoadingOutlined } from "@ant-design/icons";
import { selectCameraPermissionAsked } from "store/app/reducer";

const { Title, Paragraph } = Typography;

const CameraAccessError = () => <Alert
    message="فعالسازی دوربین"
    description="خطایی در فعالسازی دوربین رخ داد. لطفا برای شروع سفر از گزینه ورود کد دستی استفاده نمایید"
    showIcon
    type="error"
/>


class QrScannerContainer extends Component {

    constructor(props) {
        super(props);
        this.startRideReq = props.startRideReq
        this.state = {
            result: undefined,
            error: undefined,
            access: false,
            torch: false,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.result != this.state.result) {
            console.log(this.state.result)
            const scanCode = this.state.result;
            this.startRideReq({ scanCode });
        }
    }

    render() {
        const { cameraAsked, cameraPermissionAsked } = this.props
        const {torch} = this.state
        return (
            <div className='selection-methods'>
                <Row justify={'center'}>
                    <h1 className='f-30 my-1 text-center ' style={{color: '#fff', textAlign: 'center'}}> شروع سفر</h1>
                </Row>
                <Row justify={'center'}>
                    <Paragraph className='mb-1 f-14 text-center' style={{color: 'white',}}>یک کد QR روی بدنه وسیله
                        نقلیه رورو نصب شده است. آن را اسکن کنید </Paragraph>
                </Row>
                {this.state.error && <Row>
                    <CameraAccessError />
                </Row>}
                <QRScanner
                    onDetect={res => {
                        this.setState({result: res})
                    }}
                    onError={error => {
                        this.setState({error: error})
                    }}
                    cameraPermissionAsked={cameraPermissionAsked}
                    cameraAsked={cameraAsked}
                    torch={torch}
                />
                <Row justify={'center'} className="mb-1">
                    <Switch
                        checked={torch}
                        checkedChildren="چراغ قوه"
                        unCheckedChildren="چراغ قوه"
                        onChange={(checked) => { this.setState({ torch: checked }) }}
                    />
                </Row>
                <Row justify={'center'}>
                    <Button className=' btn-qr-code f-16' type='primary' shape="round"
                            onClick={event => this.props.history.push(routesConfig.typingBarcode)}> ورود کد به صورت
                        دستی</Button>
                </Row>
            </div>);
    }
}

const mapStateToProps = state => ({
    cameraPermissionAsked: selectCameraPermissionAsked(state)
})

const mapDispatchToProps = {
    cameraAsked,
}

export default connect(mapStateToProps, mapDispatchToProps)(
    withRouter(QrScannerContainer))